// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"661":"bfdae82c","928":"aa387384"}[chunkId] + ".chunk.js";
};